import type { RfqProjectBudget } from "../types";

const LAKH = 100000;
const CRORE = 10000000;

const units = (value: number, unit: number): number => Number((value / unit).toFixed(2));

export function compactMoney(value: number): string {
  const crores = units(value, CRORE);
  if (crores >= 1) return `₹${crores}Cr`;
  const lakhs = units(value, LAKH);
  if (lakhs >= 1) return `₹${lakhs}L`;
  return `₹${value.toLocaleString("en-IN")}`;
}

export function budgetLabel(budget: RfqProjectBudget | null | undefined): string | null {
  if (!budget) return null;
  if (budget.label) return budget.label;
  return Number.isFinite(budget.min) && Number.isFinite(budget.max) ? `${compactMoney(budget.min)} – ${compactMoney(budget.max)}` : null;
}
